/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* --- Product Detail (desktop): ask for a size before adding to cart ----------
   The desktop Size dropdown starts on a "SELECT SIZE" placeholder (rendered
   server-side via product.selected_variant in product-blocks.liquid). The button
   itself is left exactly as Liquid renders it — black, enabled, "ADD TO CART"
   (client request 2026-07-28: no greyed-out "SELECT SIZE" state). Instead we
   intercept the click in the CAPTURE phase, before the theme's own delegated
   add-to-cart handler, and flag the dropdown red (client request 2026-07-29: red
   border only, no "PLEASE SELECT A SIZE." text underneath).

   The interception is functional, not cosmetic: the form's hidden name="id"
   input falls back to selected_or_first_available_variant, so an un-gated click
   would silently add the FIRST size to the cart.

   Desktop-only (>=1008px); on mobile the buy buttons are hidden and the sticky
   bar handles it. See [[pdp-size-picker-desktop-dropdown]]. */
(function () {
  var DESKTOP_MIN = 1008;
  var SELECT_SELECTOR = '.ProductForm__Select--desktopOnly select';

  // The dropdown that belongs to the same product as `node`. Scope trap: the
  // Quick View modal's Add to Cart has NO .Product ancestor and never gets a
  // desktop dropdown, so falling back to `document` would gate it against the
  // underlying PDP's select. Bail instead.
  function pendingSelectFor(node) {
    if (window.innerWidth < DESKTOP_MIN) return null;
    var product = node.closest('.Product');
    if (!product) return null;
    var sel = product.querySelector(SELECT_SELECTOR);
    return sel && sel.value === '' ? sel : null;
  }

  function wrapperFor(sel) {
    return sel.closest('.ProductForm__Select--desktopOnly') || sel.parentNode;
  }

  function flagMissing(sel) {
    wrapperFor(sel).classList.add('ProductForm__Select--missing');
    sel.focus();
    if (typeof sel.showPicker === 'function') {
      try { sel.showPicker(); } catch (e) { /* not allowed without user gesture */ }
    }
  }

  function clearMissing(sel) {
    wrapperFor(sel).classList.remove('ProductForm__Select--missing');
  }

  function block(event, sel) {
    event.preventDefault();
    event.stopImmediatePropagation();
    flagMissing(sel);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ProductForm__AddToCart, .shopify-payment-button');
    if (!trigger) return;
    var sel = pendingSelectFor(trigger);
    if (sel) block(event, sel);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form.ProductForm');
    if (!form) return;
    var sel = pendingSelectFor(form);
    if (sel) block(event, sel);
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches('.ProductForm__SelectDesktop')) clearMissing(event.target);
  });
})();


document.addEventListener('change', function(event) {
  if (!event.target.matches('.ProductCard__ColorSwatchRadio')) return;

  var card = event.target.closest('.ProductCard');
  if (!card) return;

  var titleEl = card.querySelector('.ProductCard__Title');
  if (!titleEl) return;

  var link = titleEl.querySelector('a');
  if (!link) return;

  var baseTitle = titleEl.dataset.baseTitle || link.textContent.trim();
  var colorValue = event.target.value;

  link.textContent = colorValue ? baseTitle + ' - ' + colorValue : baseTitle;
});


/* --- Pinterest "Lead": enquiry form submissions ------------------------------
   Powerful Form Builder dispatches `globo.formbuilder.form.submitted` on
   `document` ONLY after its XHR comes back with success == "true", so this is a
   confirmed submission, not a click on the button. One listener covers all seven
   enquiry forms (General 155709, Bespoke 155718, Bridal 155720, Bridesmaids
   155723, Custom Colour 155726, PR 155732, Wholesale 155733).

   The Pinterest tag itself does NOT run in the theme — it lives in the sandboxed
   web pixel — so we can't call pintrk() here. Instead we hand the data to
   Shopify's customer-event bus; the "Pinterest Lead (DZO)" custom pixel
   (Settings > Customer events) subscribes to it and sends the event to
   ct.pinterest.com with tag 2612709395849.

   The e-mail is passed in clear here and hashed (SHA-256) inside the pixel
   before it ever leaves the browser — Pinterest only ever receives the hash. */
document.addEventListener('globo.formbuilder.form.submitted', function (event) {
  var detail = event.detail || {};
  var form = detail.form;

  // Field names differ per form (email, email-1, ...), so match on the value.
  function customerEmail() {
    if (!form) return '';
    var inputs = form.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      var value = (inputs[i].value || '').trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return value;
    }
    return '';
  }

  try {
    window.Shopify.analytics.publish('dzo_enquiry_submitted', {
      form_id: String(detail.formId || (form && form.getAttribute('data-id')) || ''),
      form_name: (document.querySelector('.PageHeader__Heading, h1') || {}).textContent
        ? (document.querySelector('.PageHeader__Heading, h1').textContent || '').trim()
        : document.title,
      page_url: window.location.href,
      email: customerEmail()
    });
  } catch (e) {
    /* analytics unavailable — never break the form's own success handling */
  }
});
